<div class="selected-card">
  <div class="selected-card__body">
    <img class="venue-image" loading="lazy" [src]="getLargerImage(venueData.picture)" alt="{{venueData?.name}}">
  </div>
  <div class="selected-card__footer">
    <p class="venue-name ellipsis">
      {{venueData?.name}}
    </p>
    <div class="venue-category ellipsis" title="{{venueData.types}}">
      <span class="ellipsis">
        <ng-container *ngFor="let type of venueTypes | slice:0:2">{{type}}&nbsp;</ng-container>
      </span>
    </div>

    <div class="venue-rating" *ngIf="venueData.rating != 0">
      <span>{{venueData.rating.toFixed(1)}} </span>
      <img class="star-image"
        src="assets/images/rating-star.svg" loading="lazy" alt="Rating Star">
    </div>
    <div class="venue-rating"  *ngIf="venueData.rating == 0" >
      <span>&nbsp;</span>
    </div>
  </div>
</div>
